import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "bootstrap-icons/font/bootstrap-icons.min.css";
import "./assets/vendor/font-awesome/css/all.min.css";
import * as icons from 'react-bootstrap-icons';
import "overlayscrollbars/overlayscrollbars.css";
import {
  OverlayScrollbars,
  ScrollbarsHidingPlugin,
  SizeObserverPlugin,
  ClickScrollPlugin,
} from "overlayscrollbars";

import { Choices } from "choices.js";
import GLightbox from 'glightbox';
import { Dropzone } from "dropzone";
// import Flatpickr from "flatpickr";
import flatpickr from "flatpickr";
import Plyr from "plyr";
import Zuck from "zuck.js";
// import { tns } from 'tiny-slider/src/tiny-slider';
// import 'tiny-slider/dist/tiny-slider.css';
import "./assets/css/style.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './Context/AuthProvider';

import { ToastContainer } from 'react-toastify';
import { ApiProvider } from './Context/ApiContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ApiProvider>,
        <ToastContainer style={{ marginTop: '50px', width: "max-content" }} />
        <App />
      </ApiProvider>,
    </AuthProvider>
  </React.StrictMode>
);


reportWebVitals();
